import { ApiCollection, Collection, CollectionId, StoredFile } from '../model';
import { toCollection } from '../src/toCollection';
import { loadOrganizations, Organization } from 'libs/organization';
import { httpClient, postProcessUpsert } from '@genai/http-client';
import { LoaderFunctionArgs } from 'react-router-dom';
import { listFiles } from '../src/listFiles';
import { loadUser, User } from '@genai/user';


export interface LoaderData {
  collections?: Collection[];
  organizations?: Organization[];
  files?: StoredFile[];
  embedModels?: string[];
  user: User;
}

export const loadCollections = () =>
  httpClient(`/collections`, {
    method: 'GET'
  })
    .then(postProcessUpsert<ApiCollection[]>)
    .then((collections) => collections.map(toCollection));

export const loadFiles = listFiles;

export const collectionPageLoader = async ({ params }: LoaderFunctionArgs): Promise<LoaderData> => {
  const { collectionId } = params;
  const collections = await loadCollections();
  const organizations = await loadOrganizations();
  const embedModels = await loadEmbedModelsMetrics();
  const user = await loadUser();

  if (collectionId) {
    const files = await loadFiles(collectionId as CollectionId);
    return { organizations, collections, files, embedModels, user };
  }

  return { organizations, collections, embedModels, user };
};

export const loadEmbedModelsMetrics = () =>
  httpClient('/enums/embed-models', {
    method: 'GET'
  }).then(postProcessUpsert<string[]>);
